export class PaisEntidade {
	public CD_PAIS: string;
	public DS_PAIS: string;
	public CD_PAIS_EFINANCEIRA: string;
}
